import convertToCurrency from "src/utils/convertToCurrency";
import { Order, SortOption } from "./interface";
import { hasAllAccess } from "src/utils/permissionUtils";

export const getStoreCreditHeaderConfig = (value: number) => [
    {
        key: "overShort.totAdjustedRetail",
        value: convertToCurrency("$", value),
        keyWidth: "220px"
    }
];

export const BreadCrumbConfig = [
    {
        label: "receiving",
        to: "/receive",
        translationKey: "overShort.basicData.receiving"
    },
    { label: "overShort", translationKey: "overShort.basicData.overShort" }
];

export const getTabsConfig = (t: Function) => [
    {
        hash: "manual-transfer-tab-0",
        label: t("manualTransfer.header.generalInfo")
    },
    {
        hash: "manual-transfer-tab-1",
        label: t("manualTransfer.header.items")
    },
    {
        hash: "manual-transfer-tab-2",
        label: t("manualTransfer.header.notes")
    }
];

export const getAdditionalPropsForTab = (index: number) => ({
    id: `manual-transfer-tab-${index}`,
    "aria-controls": `manual-transfer-tab-${index}`
});

export const getSortOrder = ({
    sortParamValue,
    sortOption
}: {
    sortParamValue: string;
    sortOption: SortOption;
}): Order => sortParamValue === sortOption?.sortParam && sortOption?.sortOrder === "DESC" ? "ASC" : "DESC";

export const filterOsItemsBySearchTerm = (overShortItems: any, searchTerm: any) => {
    if (!searchTerm) return overShortItems;
    return overShortItems?.filter((poItem: any) => (
        poItem?.itemId?.toString().includes(searchTerm) ||
        poItem?.description
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
    )
    );
};

export const checkApprovalUserAccessForEditApproveStoreCredit = (permissions: any) => {
    const requiredPermissions = ["edit-store-credit", "approve-store-credit"];
    return hasAllAccess(permissions, requiredPermissions);
};

export const shouldUpdateSearchIndex = (
  isLoading: boolean,
  searchResults: string | any[],
  setSearchIndex: any
) => {
  if (
    !isLoading &&
    searchResults.length % 50 === 0 &&
    searchResults.length > 0
  ) {
    setSearchIndex((prevIndex: number) => prevIndex + 1);
  }
};
